const FILE_SIZE_UNITS = ['B', 'KB', 'MB', 'GB'];

export function formatFileSize(sizeInBytes: number): string {
  if (sizeInBytes < 1024) {
    return sizeInBytes + ' ' + FILE_SIZE_UNITS[0];
  }
  let value = sizeInBytes;
  let unitIndex = 0;
  while (value >= 1024 && unitIndex < FILE_SIZE_UNITS.length - 1) {
    value = value / 1024;
    unitIndex = unitIndex + 1;
  }
  return value.toFixed(1) + ' ' + FILE_SIZE_UNITS[unitIndex];
}
